import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger, Badge ,Modal ,Row } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom'; 
import bgimage from '../../../../images/items/items.jpg';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const baseURL = process.env.REACT_APP_API_BASE_URL;

const Approve = ({ show, onClose, data, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [rawmaterialData, setRawdata] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    // const [allChecked, setAllChecked] = useState(false);

    useEffect(() => {
        if(data){
            setRawdata(data.raw_material_list);
            setHasFetched(true);
            setSelectedRows(data.raw_material_list);
        }
    }, [data]);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);

    useEffect(() => {
        if(hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        // pageLength: 25,
                        "ordering": false,
                        scrollY: "250px",
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

 

    const handleSubmit = () => {
        const payload1 = {
            menu_date: data.menu_date,
            item_id: data.menu_item_id,
            schedule_id: data.menu_schedule_id,
            branch_id: branch_id,
            user_id: user_id
        };
        const payload2 = {
            consumed_date: data.request_date,
            menu_date: data.menu_date,
            consumed_schedule_id: data.menu_schedule_id,
            materials: selectedRows.map(item => ({
                raw_material_id: item.raw_material_id,
                consumed_qty: item.total_quantity,
                unit_id: item.unit_id
            })),
            branch_id: branch_id,
            user_id: user_id
        };

        const consumeRequest = axios.post(`${baseURL}/stock/consume-multiple`, payload2 );
        const updateStatusRequest = axios.post(`${baseURL}/stock-requests/update-status`, payload1 );

        Promise.all([consumeRequest, updateStatusRequest])
            .then(() => {
                toast.success("Consumption Approved Successfully!");
                refresh();
                onClose();
            })
            .catch((error) => {
                console.error('There was an error!', error);
                toast.error("Consumption Approve Failed!");
                refresh();
                onClose();
            });

    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Approve Raw Materials</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row mb-2'>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <div className="d-flex align-items-start justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={data.item_image || bgimage} className='border rounded px-1 py-0'>
                                        <img src={data.item_image || bgimage} alt={data.menu_item_name} className='cursor-pointer w-50px h-50px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Item Name</span></Tooltip>} >
                                        <label className='text-black font-w500 fs-5'>{data.menu_item_name}</label>
                                    </OverlayTrigger>
                                    <div className="d-block">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Item Category</span></Tooltip>} >
                                            <div className="fs-7 text-black">{data.itemcategory_name}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-4 d-flex flex-column pt-1'>
                            <label className="fs-7 text-black mb-0 font-w500">Items Schedule</label>
                            <label className="fs-6 text-danger mb-0 font-w500">{data.menu_schedule_name}</label>
                        </div>
                        <div className='col-lg-4 d-flex flex-column pt-1'>
                            <label className="fs-7 text-black mb-0 font-w500">Date</label>
                            <label className="fs-6 text-danger mb-0 font-w500">{formatDate(data.menu_date)}</label>
                        </div>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Total Quantity</label>
                            <span>
                                <Badge as="a" href="" bg="badge" className='badge-outline-danger fw-bold fs-6'> {data.total_quantity ? data.total_quantity : '-'} </Badge>
                            </span>
                        </div>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Total Raw Materials Needed</label>
                            <span>
                                <Badge as="a" href="" bg="badge" className='badge-outline-danger fw-bold fs-6'> {data.raw_material_count} </Badge>
                            </span>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='tabel-container'>
                            <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        
                                        <th className='min-w-100px'>Raw Materials</th>
                                        <th className='min-w-80px'>Qty / Units</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {rawmaterialData.map((rmdata, index) => (
                                        <tr key={rmdata.raw_material_id}>
                                            
                                            <td>
                                                <div className="fs-7 text-black mb-0 font-w500 d-block">{rmdata.raw_material_name}</div>
                                            </td>
                                            <td>
                                                <Badge bg="primary" className="fs-7 font-w500 px-1 ms-4 mt-1 py-0 px-3">{rmdata.raw_material_quantity}</Badge>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                     <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Approve
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Approve;